
















































import Vue from 'vue'
import {secondsToHms} from "@/ts/utils";
import {TestResult} from "@/ts/types";
import TestResultView from "@/components/TestResultView.vue";

export default Vue.extend({
    name: 'ExperimentResult',
    components: {TestResultView},
    data: () => ({}),
    async mounted() {
        try {
            this.downloadResults();
        } catch (e) {
            alert("Don't forget to download your results!");
        }
        console.log(this.learnResults);
        if (!this.learnResults ||
            (!this.learnResults[0] || this.learnResults[0].history.length === 0) &&
            (!this.learnResults[1] || this.learnResults[1].history.length === 0)) {
            console.warn("No known game result, redirecting to homepage");
            return await this.$router.push('/experiment');
        }
        await this.$store.dispatch('initRandomFlags');
    },
    methods: {
        downloadResults() {
            this.$store.dispatch('downloadResults');
        },
        toHms(s: number) {
            return secondsToHms(s);
        },
    },
    computed: {
        learnResults(): null | { [key: string]: TestResult } {
            return this.$store.state.learnResults;
        },
        testResults(): null | { [key: string]: TestResult } {
            return this.$store.state.testResults;
        },
        countries(): { [key: string]: string }[] {
            return this.$store.state.countries;
        },
        randomFlags(): string[] {
            return this.$store.state.randomFlags;
        },
    },
})
